import { FC, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Box, styled, themeGet } from '@qwealth/qcore';

import { resetTradeRequests } from 'data/actions/tradeRequests';
import { tradeRequestsRoute } from 'data/refData/tradeRequests';
import { useAppDispatch } from 'data/store';
import TradeRequestsPage from './TradeRequestsPage';

const StyledHeader = styled(Box)`
  background-color: ${themeGet('colors.primary')};
  color: ${themeGet('colors.white')};
  padding: ${themeGet('space.default')};
  font-size: ${themeGet('fontSizes.appTitle')};
  font-weight: ${themeGet('fontWeights.bold')};
  border-radius: ${themeGet('radii.default')};
`;

const TradeRequestsPage_: FC = (): JSX.Element => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetTradeRequests());
    };
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column" marginBottom="large" boxShadow="layout">
        <StyledHeader>{tradeRequestsRoute.label}</StyledHeader>
      </Box>
      <Routes>
        <Route path="/" element={<TradeRequestsPage />} />
      </Routes>
    </Box>
  );
};

export default TradeRequestsPage_;
